import { Link } from 'react-router-dom'
import { useLocation } from 'react-router-dom'

export default function BookingSuccess() {
  const location = useLocation()
  const state = location.state as any

  return (
    <div className="page-container pb-20">
      <div className="text-center py-12">
        <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-green-100 flex items-center justify-center">
          <svg className="w-10 h-10 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>
        
        <h1 className="text-2xl font-bold text-gray-900 mb-2">预约成功！</h1>
        <p className="text-gray-600 mb-8">我们会尽快确认您的预约</p>

        <div className="card text-left mb-6">
          <h2 className="font-semibold text-gray-900 mb-4">预约详情</h2>
          <div className="space-y-3 text-sm">
            <div className="flex justify-between">
              <span className="text-gray-500">服务项目</span>
              <span className="text-gray-900 font-medium">{state?.service?.name}</span>
            </div>
            {state?.beautician && (
              <div className="flex justify-between">
                <span className="text-gray-500">美容师</span>
                <span className="text-gray-900 font-medium">{state.beautician.name}</span>
              </div>
            )}
            <div className="flex justify-between">
              <span className="text-gray-500">预约时间</span>
              <span className="text-gray-900 font-medium">
                {state?.date} {state?.time}
              </span>
            </div>
          </div>
        </div>

        <div className="space-y-3">
          <Link to="/" className="btn-primary w-full block">
            返回首页
          </Link>
          <a href="tel:4008888888" className="btn-secondary w-full block">
            联系我们
          </a>
        </div>
      </div>
    </div>
  )
}
